const STORAGE_KEY_PREFIX = 'gpwebapp.selectedTenant.v1';

export const getSelectedTenantStorageKey = (scopeId) => `${STORAGE_KEY_PREFIX}.${scopeId}`;

export const readSelectedTenantId = (scopeId) => {
  if (!scopeId || typeof window === 'undefined') {
    return null;
  }

  try {
    return window.localStorage.getItem(getSelectedTenantStorageKey(scopeId)) || null;
  } catch {
    return null;
  }
};

export const writeSelectedTenantId = (scopeId, tenantId) => {
  if (!scopeId || typeof window === 'undefined') {
    return;
  }

  try {
    const storageKey = getSelectedTenantStorageKey(scopeId);
    if (tenantId) {
      window.localStorage.setItem(storageKey, tenantId);
    } else {
      window.localStorage.removeItem(storageKey);
    }
  } catch {
    // Ignore storage failures (private mode, quota, etc.)
  }
};
